import { element } from 'protractor';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { Subscription } from 'rxjs/Subscription';
import { SharedService } from '../../../shared/services/share.services';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { PriceListModel } from '../../../models/centre/price.model';
import { ManagePriceListService } from './manage-price-list.service';
import { UserType } from '../../../shared/constants/permission';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { AddPricePopUpComponent } from './add-price-popup.component';
import { EditPricePopUpComponent } from './edit-price-popup.component';

@Component({
  selector: 'manage-price-list',
  templateUrl: './manage-price-list.component.html',
  providers: [ManagePriceListService]
})

export class ManagePriceComponent extends TMBDataTableComponent implements OnInit {
  public dataRow = new Array<PriceListModel>();
  public isSysAdmin = false;
  public filterData = {
    modelId: null,
    categoryId: null,
    countryId: null,
    centreId: null,
    currency: '',
  };

  public listModel: Array<string> = null;
  public listCountry: any;
  public listCentre: any;
  public listCurencies = [];
  public productCategory: any;
  public countItemModel: number; // count item in model
  public listCategory = [];
  public categoryName: string;
  public countrySelected: any;
  public defaultCurrency: string;
  // currency Model
  public selectedCurrency: any = {
    code: '',
    id: '',
    symbol: '',
    symbolPosition: 'L',
    rate: 1
  };

  constructor(
    public utility: Utility,
    private managePriceListService: ManagePriceListService,
    public dialogService: DialogService,
    public sharedService: SharedService) {
      super(sharedService);
    this.filterData.centreId = localStorage.getItem(AppConstants.localStorage.centreId);

  }

  ngOnInit() {
    this.isSysAdmin = localStorage.getItem(AppConstants.localStorage.userType) === UserType.SystemAdmin;
    this.getModel();
    this.getCentre();
    this.getDefaultCurrency();

    // Get list currency and setPage
    this.getCurrency();
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      modelId: this.filterData.modelId === null ? 'Vaccines' : this.filterData.modelId,
      centreId: this.filterData.centreId === null ? '' : this.filterData.centreId,
      currency: this.filterData.currency,
      productCategoryId: this.filterData.categoryId
    };

    // call API
      this.managePriceListService.getPriceList(param).subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.dataRow = data['list'];
          this.page.totalElements = data['totalRecords'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          // Update seleced currency
          this.updateSelectedCurrency(this.filterData.currency);
        }
      }
    );
  }

  getModel() {
    this.managePriceListService.getModelList().subscribe(
      result => {
        this.listModel = result.json();
        this.filterData.modelId = this.listModel.find(m => m === 'Vaccines');
      },
    );
  }

  getCentre() {
    this.managePriceListService.getCentreList().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.listCentre = data;
        }
      }
    );
  }

  getCurrency() {
    this.managePriceListService.getCurrencies(this.filterData.centreId).subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.listCurencies = data;
          this.setPage({ offset: 0 });
        }
      }
    );
  }

  getDefaultCurrency() {
    this.managePriceListService.getDefaultCurrency(this.filterData.centreId).subscribe(
      resultDefaultCurreny => {
        if (resultDefaultCurreny) {
          this.filterData.currency = resultDefaultCurreny.text();
          this.defaultCurrency = resultDefaultCurreny.text();
        }
      }
    );
  }

  /**
   * Call when change model
   */
  onModelChange(event) {
    if (event.target.value === 'Products' && this.listCategory.length <= 0) {
      // load product category
      this.managePriceListService.getProductCategoryList().subscribe(
        result => {
          if (result) {
            const data = result.json();

            this.listCategory = data['list'];
            if (this.listCategory.length > 0) {
              this.filterData.categoryId = this.listCategory[0]['id'];
              this.categoryName = this.listCategory[0]['name'];
            }

            // Reload list
            this.setPage({ offset: 0 });
          }
        }
      );
    } else {
      this.categoryName = '';
      this.setPage({ offset: 0 });
    }
  }

  /**
   * Call when change centre
   */
  onCentreChange(event) {
    this.getDefaultCurrency();
    this.setPage({ offset: 0 });
  }

  /**
   * Call when change currency
   */
  onChangeCurrency() {
    this.updateSelectedCurrency(this.filterData.currency);
  }

  /**
   * function update price list when user change category
   * @param event
   */
  onCategoryChange(event) {
    this.categoryName = this.listCategory.find(item => item.id === event.target.value).name;
    this.filterData.categoryId = event.target.value;
    this.setPage({ offset: 0 });
  }

  /**
	 * update selectedCurrency model when user change currency
	 * @param currencyId String : currency Id that user selected in Currency select box
	 */
  updateSelectedCurrency(currencyCode) {
    const currency = this.listCurencies.filter(c => c.code === currencyCode);
    if (currency.length > 0) {
        this.selectedCurrency = currency[0];
    }
  }

  roundPriceNumber(num) {
    return Math.round(num * 100) / 100;
  }


  onNewPrice() {
    const data = {
      centreId: (this.filterData.centreId !== null) ? this.filterData.centreId : localStorage.getItem(AppConstants.localStorage.centreId),
      typeId: this.filterData.modelId,
      productCategoryId: this.filterData.categoryId
    };
    this.dialogService.openComponentDialog(AddPricePopUpComponent, data).subscribe(result => {
      // if add price success then reload the list
      if (result) {
        this.reloadPage(this.page.pageNumber, this.dataRow);
      }
    });
  }

  onEditItem(item) {
    // get centre name base on selected centre
    let centreName = '';
    if (this.filterData.centreId === null) {
      centreName = localStorage.getItem(AppConstants.localStorage.centreName);
    } else {
      centreName = this.listCentre.find(c => c.centreId === this.filterData.centreId)['centreName'];
    }
    const data = {
      id: item.id,
      consultationfeeId : item.consultationFeeId,
      name : item.item,
      modelId : this.filterData.modelId,
      costPrice : this.roundPriceNumber(item.costPrice),
      defaultPrice : this.roundPriceNumber(item.defaultPrice),
      clinicPrice : this.roundPriceNumber(item.clinicPrice),
      taxPrice : item.taxPrice,
      centreName: centreName,
      centreId : this.filterData.centreId,
      productCategoryName : this.categoryName,
      listCurencies: this.listCurencies,
      currencyCode: this.defaultCurrency
    };

    this.dialogService.openComponentDialog(EditPricePopUpComponent, data).subscribe(result => {
      // if add price success then reload the list
      if (result) {
        this.reloadPage(this.page.pageNumber, this.dataRow);
      }
    });
  }

  onRemoveItem(row) {
    const param = {
      id : row.id,
      modelId : this.filterData.modelId
    };

    this.dialogService.openConfirmationDialog({ message: AppMessages.price.removePrice }).subscribe(
      (result) => {
          if (result) {
            if (param.modelId !== 'Consultations') {
              this.managePriceListService.removePriceItem(param).subscribe(
                (resultTemp) => {
                  if (resultTemp) {
                    this.reloadPage(this.page.pageNumber, this.dataRow, true);

                  }
                }
              );
            } else {
              this.managePriceListService.removePriceConsultation(row.consultationFeeId).subscribe(
                result1 => {
                  if (result1) {
                    this.reloadPage(this.page.pageNumber, this.dataRow, true);

                  }
                }
              );
            }
          }

      }
  );
  }

  /**
   * change taxNum to %
   * @param taxNum
   */
  changeTaxPrice(taxNum) {
    return this.roundPriceNumber(parseFloat(taxNum) * 100);
  }

}






// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-price/manage-price-list.component.ts